// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d938a912","977":"88d4db41"}[chunkId] + ".chunk.js";
};